<template>
  <div>
    <div class="nav-box">
      <Nav></Nav>
    </div>
    <div class="head">
      <img
        src="@/assets/净颜卸妆/1_01.png"
        alt=""
      >
      <div class="router-pages">
        <div
          @click="goPages('remover')"
          :class="tag=='remover'?'active':''"
        >
          卸妆
        </div>
      </div>
    </div>
    <remover v-if="tag=='remover'"></remover>

    <div>
      <Bot></Bot>
    </div>
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue';
import Bot from '@/components/Bot.vue';
import remover from './components/remover';

export default {
  data() {
    return {
      productArr: [],
      tag: 'remover'
    }
  },
  components: {
    Nav, Bot, remover
  },
  methods: {
    goPages(paTh) {
      this.tag = paTh
    }
  },
}
</script>

<style lang="scss" scoped>
.head {
  img {
    width: 100%;
  }
  position: relative;
}
.router-pages {
  position: absolute;
  top: 70%;
  right: 50%;
  transform: translateX(50%);
  box-sizing: border-box;
  display: flex;
  div {
    font-size: 1.5625rem;
    padding-bottom: 0.525rem;
    margin: 0 3.75rem;
    cursor: pointer;
    span {
      line-height: 1;
      padding-bottom: 0.3rem;
    }
  }
  .active {
    font-weight: 700;
    border-bottom: black 2px solid;
  }
  div:hover {
    font-weight: 700;
  }
}
@keyframes text-border {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
</style>